<template>
	<div class="flex-1">
		<div class="flex h-full w-full flex-col bg-white shadow-xl p-6">
			<div class="flex flex-col h-full">
				<div class="flex items-start justify-between mb-6">
					<h2
						id="slide-over-title"
						class="text-lg capitalize font-medium text-gray-900 py-0"
					>
						{{ $t("signup") }}
					</h2>
					<div class="ml-3 flex h-7 items-center">
						<button
							type="button"
							class="-m-2 p-2 text-gray-700"
							@click="emits('close')"
						>
							<span class="sr-only">Close panel</span>
							<XMarkIcon class="w-6 h-6" />
						</button>
					</div>
				</div>

				<div class="flex-1 min-h-0">
					<form
						class="flex-1 min-h-0 flex flex-col gap-6"
						@submit.prevent="invokeSubmit"
					>
						<p>{{ $t("create_a_new_account") }}</p>
						<div>
							<label
								class="text-sm font-medium text-gray-700 mb-1"
								for="email"
								:class="{
									'text-red-600': $v.Email.$error
								}"
								>{{ $t("email_address") }} aa
							</label>
							<input
								id="email-address"
								v-model="formData.Email"
								name="Email"
								type="email"
								autocomplete="email"
								class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
								:class="{
									'border-red-600': $v.Email.$error
								}"
							/>
							<span
								v-if="$v.Email.$error"
								class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
							>
								{{
									$t(`validation.${($v.Email.$errors[0].$params as any).type}`)
								}}
							</span>
						</div>
						<div>
							<label
								class="text-sm font-medium text-gray-700 mb-1"
								:class="{
									'text-red-600': $v.FirstName.$error
								}"
								for="firstname"
								>{{ $t("first_name") }}
							</label>
							<input
								id="firstname"
								v-model="formData.FirstName"
								name="FirstName"
								type="text"
								autocomplete="Firstname"
								:class="{
									'border-red-600': $v.FirstName.$error
								}"
								class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
							/>
							<span
								v-if="$v.FirstName.$error"
								class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
							>
								{{
									$t(
										`validation.${
											($v.FirstName.$errors[0].$params as any).type
										}`,
										$v.FirstName.$errors[0].$params as any
									)
								}}
							</span>
						</div>
						<div>
							<label
								class="text-sm font-medium text-gray-700 mb-1"
								:class="{
									'text-red-600': $v.LastName.$error
								}"
								for="lastname"
								>{{ $t("last_name") }}
							</label>
							<input
								id="lastname"
								v-model="formData.LastName"
								name="LastName"
								type="text"
								autocomplete="Lastname"
								:class="{
									'border-red-600': $v.LastName.$error
								}"
								class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
							/>
							<span
								v-if="$v.LastName.$error"
								class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
							>
								{{
									$t(
										`validation.${
											($v.LastName.$errors[0].$params as any).type
										}`,
										$v.LastName.$errors[0].$params as any
									)
								}}
							</span>
						</div>
						<div>
							<label
								class="capitalize text-sm font-medium text-gray-700 mb-1"
								:class="{
									'text-red-600': $v.Password.$error
								}"
								for="password"
								>{{ $t("password") }}
							</label>
							<input
								id="password"
								v-model="formData.Password"
								name="Password"
								type="password"
								autocomplete="password"
								:class="{
									'border-red-600': $v.Password.$error
								}"
								class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
							/>
							<span
								v-if="$v.Password.$error"
								class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
							>
								{{
									$t(
										`validation.${
											($v.Password.$errors[0].$params as any).type
										}`,
										$v.Password.$errors[0].$params as any
									)
								}}
							</span>
						</div>
						<div>
							<label
								class="capitalize text-sm font-medium text-gray-700 mb-1"
								:class="{
									'text-red-600': $v.InvoiceAddress.Line1.$error
								}"
								for="street"
								>{{ $t("street_address") }}
							</label>
							<input
								id="street"
								v-model="formData.InvoiceAddress.Line1"
								name="street"
								type="text"
								autocomplete="street"
								:class="{
									'border-red-600': $v.InvoiceAddress.Line1.$error
								}"
								class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
							/>
							<span
								v-if="$v.InvoiceAddress.Line1.$error"
								class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
							>
								{{
									$t(
										`validation.${
											($v.InvoiceAddress.Line1.$errors[0].$params as any).type
										}`,
										$v.InvoiceAddress.Line1.$errors[0].$params as any
									)
								}}
							</span>
						</div>
						<div class="flex gap-4">
							<div class="w-1/3">
								<label
									class="text-sm font-medium text-gray-700 mb-1"
									for="zipcode"
									:class="{
										'text-red-600': $v.InvoiceAddress.Zip.$error
									}"
									>{{ $t("zip_code") }}
								</label>
								<input
									id="zipcode"
									v-model="formData.InvoiceAddress.Zip"
									name="Zip"
									type="text"
									autocomplete="zipcode"
									:class="{
										'border-red-600': $v.InvoiceAddress.Zip.$error
									}"
									class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
								/>
								<span
									v-if="$v.InvoiceAddress.Zip.$error"
									class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
								>
									{{
										$t(
											`validation.${
												($v.InvoiceAddress.Zip.$errors[0].$params as any).type
											}`,
											$v.InvoiceAddress.Zip.$errors[0].$params as any
										)
									}}
								</span>
							</div>
							<div class="w-2/3">
								<label
									class="text-sm font-medium text-gray-700 mb-1"
									for="city"
									:class="{
										'text-red-600': $v.InvoiceAddress.City.$error
									}"
									>{{ $t("city") }}
								</label>
								<input
									id="city"
									v-model="formData.InvoiceAddress.City"
									name="city"
									type="text"
									autocomplete="city"
									:class="{
										'border-red-600': $v.InvoiceAddress.City.$error
									}"
									class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm"
								/>
								<span
									v-if="$v.InvoiceAddress.City.$error"
									class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
								>
									{{
										$t(
											`validation.${
												($v.InvoiceAddress.City.$errors[0].$params as any).type
											}`,
											$v.InvoiceAddress.City.$errors[0].$params as any
										)
									}}
								</span>
							</div>
						</div>

						<div>
							<label
								class="text-sm font-medium text-gray-700 mb-1"
								:class="{
									'text-red-600': $v.InvoiceAddress.CountryId.$error
								}"
								for="country"
								>{{ $t("country") }}
							</label>
							<SwSelect
								id="country"
								v-model="formData.InvoiceAddress.CountryId"
								:compact="false"
								name="CountryId"
								autocomplete="country-name"
								:options="getCountriesOptions"
								:placeholder="$t('choose_country_placeholder')"
								:class="{
									'border-red-600': $v.InvoiceAddress.CountryId.$error
								}"
							/>
							<span
								v-if="$v.InvoiceAddress.CountryId.$error"
								class="text-red-600 text-sm focus:ring-brand-primary border-gray-300 rounded"
							>
								{{
									$t(
										`validation.${
											($v.InvoiceAddress.CountryId.$errors[0].$params as any)
												.type
										}`,
										$v.InvoiceAddress.CountryId.$errors[0].$params as any
									)
								}}
							</span>
						</div>
						<div class="">
							<SharedCheckbox
								id="agree"
								v-model="formData.agree"
								:content="
									$t('agree_data_protection', [
										`<a class='underline' target='_blank' href='#'>${$t(
											'data_protection_information'
										)}</a>`,
										`<a class='underline' target='_blank' href='#'>${$t(
											'general_terms_and_conditions'
										)}</a>`
									])
								"
								:error="!!$v.agree.$error"
							/>
						</div>
						<button
							type="submit"
							class="flex capitalize items-center justify-center px-5 py-2 text-base font-medium text-white shadow-sm bg-gray-800 disabled:opacity-50 hover:bg-gray-900 transition ease-in-out duration-200"
							:disabled="loading"
						>
							{{ $t("create_account") }}
						</button>
					</form>
					<nuxt-link
						class="mt-5 block text-center cursor-pointer font-medium text-base underline"
						@click="openLogin"
						>{{ $t("or_log_in_to_your_account") }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { required, email, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { onMounted, ref, inject, computed } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import type { SharedModal } from "~/layers/base/components/Shared/SharedModal.vue";

interface FormDataCreateAccount {
	FirstName: string;
	LastName: string;
	Email: string;
	Password: string;
	agree: boolean;
	Account: {
		LoginName: string;
		Name: string;
		Roles: null | number[];
		IsActive: boolean;
	};
	InvoiceAddress: {
		Line1: string;
		Zip: string;
		City: string;
		CountryId: number | undefined;
		Country: string;
	};
}

const { $toast } = useNuxtApp();
const emits = defineEmits<{
	(e: "success"): void;
	(e: "close"): void;
}>();

const { createAccount } = useNorcePwa();
const { executeRecaptcha } = useRecaptcha();
const modal = inject<SharedModal>("modal") as SharedModal;
const loading = ref();
const router = useRouter();
const pageStore = usePageStore();
const isProductPage = computed(() => pageStore.pageType === "product");

const getCountriesOptions = ref<{ label: string; value: number }[]>([]);
const { applicationNorce } = storeToRefs(useNorceStore());
const Countries = applicationNorce?.value?.Countries;

const setup = async () => {
	getCountriesOptions.value =
		Countries?.List?.map((country) => ({
			label: country.Name,
			value: country.Id
		})) ?? [];
};

const formData = ref<FormDataCreateAccount>({
	FirstName: "",
	LastName: "",
	Email: "",
	Password: "",
	agree: false,
	Account: {
		LoginName: "",
		Name: "",
		Roles: null,
		IsActive: true
	},
	InvoiceAddress: {
		Line1: "",
		Zip: "",
		City: "",
		CountryId: 0,
		Country: "Sverige"
	}
});

const rules = computed(() => ({
	FirstName: {
		required,
		minLength: minLength(3)
	},
	LastName: {
		required,
		minLength: minLength(3)
	},
	Email: {
		required,
		email
	},
	Password: {
		required,
		minLength: minLength(8)
	},
	Account: {
		LoginName: {
			required,
			minLength: minLength(3)
		}
	},
	InvoiceAddress: {
		Line1: {
			required,
			minLength: minLength(3)
		},
		// Only required: postal codes range from 4 digits (NO, DK) to "1234 AB"
		// (NL) and "SW1A 1AA" (UK). Same rule as base useAccountSignUp.
		Zip: {
			required
		},
		City: {
			required
		},
		CountryId: {
			required
		}
	},
	agree: {
		checked: (value: boolean) => value
	}
}));

const $v = useVuelidate<FormDataCreateAccount>(rules, formData);
const localePath = useLocalePath();
const { t, locale } = useI18n();
const cartStore = useCartStore();

const invokeSubmit = async () => {
	$v.value.$touch();
	const valid = await $v.value.$validate();

	if (valid) {
		try {
			loading.value = true;

			if (
				formData?.value?.Account?.Name &&
				formData.value.InvoiceAddress?.Country
			) {
				formData.value.Account.Name =
					formData.value.FirstName + " " + formData.value.LastName;
				if (Countries?.List) {
					const countryName = Countries.List?.filter(
						(country) =>
							country.Id === formData?.value?.InvoiceAddress?.CountryId
					)[0]?.Name;
					if (countryName) {
						formData.value.InvoiceAddress.Country = countryName;
					}
				}
			}

			const password = formData.value.Password;
			const recaptchaToken = await executeRecaptcha("signup");

			const user = await createAccount(
				{
					password,
					customer: formData.value.Email,
					localeCode: locale.value
				},
				formData.value,
				recaptchaToken
			);

			if (user) {
				userStore().setUser(user);
				$toast.success(t("successfulLogin"));
				if (!isProductPage.value) {
					router.push(localePath("/account"));
				} else {
					await cartStore.initCartUser();
				}
			}

			emits("close");
		} catch (error) {
			const message =
				error?.data?.message ||
				error?.data?.statusMessage ||
				error?.statusMessage ||
				error?.message ||
				"Account register error";
			if (isNorcePwaError(error)) {
				$toast.error(message);
			}
		} finally {
			loading.value = false;
		}
	}
};

const openLogin = () => {
	emits("close");
	setTimeout(() => {
		modal.open("AccountLoginForm", {
			position: "side"
		});
	}, 300);
};

onMounted(() => {
	setup();
});

watch(
	() => formData.value.Email,
	(newEmail: string) => {
		formData.value.Account.LoginName = newEmail || "";
	}
);
</script>
